import React from "react";

function InterplayRocket() {
  return (
    <svg
      width="36"
      height="37"
      viewBox="0 0 36 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Group 8">
        <circle id="Ellipse 1" cx="18" cy="18.2241" r="18" fill="white" />
        <g id="Group 7">
          <path
            id="Vector"
            d="M14.4504 25.0754L14.0922 24.8686L13.734 24.6618C13.4645 24.5062 13.1201 24.611 12.9828 24.89L11 30.2242L14.6281 25.8404C14.8013 25.5819 14.7195 25.231 14.4504 25.0758V25.0754Z"
            fill="#F8762E"
          />
          <path
            id="Vector_2"
            d="M21.187 17.2595C21.2447 17.1612 21.3021 17.0626 21.3594 16.9632C24.4103 11.6787 24.856 6.22412 24.856 6.22412C24.856 6.22412 20.3548 9.33732 17.3039 14.6218C17.2466 14.7212 17.19 14.8202 17.1334 14.9192L12.6907 15.23C12.0447 15.4032 11.6616 16.0672 11.8344 16.7128L14.1097 21.378C13.8864 22.0252 13.7156 22.6154 13.6032 23.1327C13.5722 23.2749 13.6754 23.4476 13.8509 23.5489L15.3536 24.4167C15.5291 24.518 15.7305 24.5211 15.8379 24.4232C16.2298 24.0673 16.6556 23.6243 17.1044 23.1074L22.2822 22.7454C22.9283 22.5722 23.3113 21.9082 23.1385 21.2626L21.1863 17.2599L21.187 17.2595ZM16.573 16.9227L14.0929 17.0098L14.0772 17.0374L15.2416 19.2289L14.7129 20.1448L13.0508 16.8913L13.4533 16.1941L17.1021 16.0068L16.5734 16.9227H16.573ZM19.6908 13.634C19.903 13.2667 20.3728 13.1409 20.7402 13.3531C21.1075 13.5652 21.2333 14.035 21.0211 14.4024C20.809 14.7697 20.3392 14.8955 19.9718 14.6834C19.6044 14.4712 19.4787 14.0014 19.6908 13.634ZM21.5204 21.7813L17.8716 21.9686L18.4003 21.0527L20.8801 20.9656L20.8957 20.938L19.7313 18.7465L20.26 17.8306L21.9221 21.0841L21.5196 21.7813H21.5204Z"
            fill="#4D99E6"
          />
        </g>
      </g>
    </svg>
  );
}

export default InterplayRocket;
